import { useLocation, useParams } from 'react-router-dom';
import { useProjects } from '../api/hooks/useProjects';
import { useScenes } from '../api/hooks/useScenes';
import { useShots } from '../api/hooks/useShots';
import type { BreadcrumbSegment } from '../components/Breadcrumb';

export function useBreadcrumb(): BreadcrumbSegment[] {
  const { id: projectId, sceneId } = useParams();
  const { search } = useLocation();
  const shotId = new URLSearchParams(search).get('shot');

  const projectIdNum = projectId ? Number(projectId) : 0;
  const sceneIdNum = sceneId ? Number(sceneId) : 0;

  const { data: projects } = useProjects();
  const { data: scenes } = useScenes(projectIdNum);
  const { data: shots } = useShots(sceneIdNum);

  const segments: BreadcrumbSegment[] = [];

  if (projectId) {
    const project = projects?.find(p => p.id === Number(projectId));
    segments.push({ label: project?.name ?? '…', to: `/projects/${projectId}` });
  }
  if (sceneId) {
    const scene = scenes?.find(s => s.id === Number(sceneId));
    segments.push({ label: scene?.name ?? '…', to: `/projects/${projectId}/scenes/${sceneId}` });
  }
  if (shotId) {
    const shot = shots?.find(s => s.id === Number(shotId));
    segments.push({
      label: shot ? `Shot ${shot.shot_number}${shot.beat_notes ? ' — ' + shot.beat_notes : ''}` : '…',
    });
  }

  return segments;
}
